/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetAvailablePermissions$Params {
}

export function getAvailablePermissions(http: HttpClient, rootUrl: string, params?: GetAvailablePermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<'MANAGE_DIANA' | 'MANAGE_ONLINE_API' | 'MANAGE_TENANT' | 'VIEW_TENANT' | 'MANAGE_ORG_UNIT' | 'VIEW_ORG_UNIT' | 'MANAGE_SETTING' | 'VIEW_SETTING' | 'MANAGE_ROLES' | 'VIEW_ROLES' | 'MANAGE_USERS' | 'VIEW_USERS' | 'MANAGE_APPOINTMENTS' | 'VIEW_APPOINTMENTS' | 'MANAGE_CUSTOMER' | 'VIEW_CUSTOMER' | 'MANAGE_MEDICAL_HISTORY' | 'VIEW_MEDICAL_HISTORY' | 'MANAGE_NEW_CUSTOMER' | 'MANAGE_USERPROFILE'>>> {
  const rb = new RequestBuilder(rootUrl, getAvailablePermissions.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<'MANAGE_DIANA' | 'MANAGE_ONLINE_API' | 'MANAGE_TENANT' | 'VIEW_TENANT' | 'MANAGE_ORG_UNIT' | 'VIEW_ORG_UNIT' | 'MANAGE_SETTING' | 'VIEW_SETTING' | 'MANAGE_ROLES' | 'VIEW_ROLES' | 'MANAGE_USERS' | 'VIEW_USERS' | 'MANAGE_APPOINTMENTS' | 'VIEW_APPOINTMENTS' | 'MANAGE_CUSTOMER' | 'VIEW_CUSTOMER' | 'MANAGE_MEDICAL_HISTORY' | 'VIEW_MEDICAL_HISTORY' | 'MANAGE_NEW_CUSTOMER' | 'MANAGE_USERPROFILE'>>;
    })
  );
}

getAvailablePermissions.PATH = '/api/roles/available-permissions';
